// 开发环境
if (process.env.NODE_ENV === "development") {
  window.authBaseUrl = "http://towerwx.realsun.me/WxAuth/OAuth?returnUrl=";
  window.returnUrl = "http://localhost:3000/";
  window.returnRegisterURL = "http://localhost:3000/register";
  window.host = "http://localhost:3000";
  window.baseURL = "http://kingofdinner.realsun.me:1101/";
  window.liveUrl='https://tower.realsun.me';
  window.otpUrl='https://towerwx.realsun.me';
  window.returnUrl2 = "http://localhost:3000/LiveClientRoom?room=";
  // 生产环境
} else {
  window.authBaseUrl = "http://towerwx.realsun.me/WxAuth/OAuth?returnUrl=";
  window.returnUrl = "http://ivf.dybhealth.com:1103/";
  window.returnRegisterURL = "http://finisarinterview.realsun.me/register";
  window.host = "http://finisarinterview.realsun.me";
  window.baseURL = "https://finisar26.realsun.me:1101/";
  window.liveUrl='https://tower.realsun.me';
  window.otpUrl='https://towerwx.realsun.me';
  window.returnUrl2 = "http://ivf.dybhealth.com:1103/LiveClientRoom?room=";

}
